import { distinctUntilChanged, filter, Observable } from 'rxjs';

export function distinctAuthenticatedState(source: Observable<boolean>): Observable<boolean> {
  return source.pipe(
    distinctUntilChanged(),
    filter((value) => value)
  );
}
